/**
 * Search Box lists limits
 */
export const LATEST_SEARCH_LIMIT = 2

export const KEYWORD_SEARCH_LENGTH = 3


/**
 * Types of filters
 */
export const FILTER_DATES = 'dates'
export const FILTER_ROOMS = 'rooms'
export const FILTER_MORE = 'more'
export const FILTER_SORT = 'sort'
export const FILTER_CODE = 'code'

/**
 * Show More filters filter if hotels results is more or equal this value
 * @type {number}
 */
export const FILTER_MORE_MIN_HOTELS_COUNT = 5

export const ACTIVE_NONE = 'none'


export const SEARCH_FILTERS_FORM = 'searchFiltersForm'

/**
 * Redux action types
 */
export const SORT_CHANGE = 'Forms.searchFilters.SORT_CHANGE'
export const FILTER_CHANGE = 'Forms.searchFilters.FILTER_CHANGE'
export const FILTER_APPLY = 'Forms.searchFilters.FILTER_APPLY'
export const FILTER_CLEAR = 'Forms.searchFilters.FILTER_CLEAR'
export const ROOM_REMOVE = 'Forms.searchFilters.ROOM_REMOVE'
export const CHANGE_MULTIPLE = 'Forms.searchFilters.CHANGE_MULTIPLE'
export const FILTER_BACKUP = 'Forms.searchFilters.FILTER_BACKUP'
export const PRICE_CHANGE = 'Forms.searchFilters.PRICE_CHANGE'
export const AMENITY_CHANGE = 'Forms.searchFilters.AMENITY_CHANGE'
export const CODE_CHANGE = 'Forms.searchFilters.CODE_CHANGE'
export const HOTEL_TYPE_CHANGE = 'Forms.searchFilters.HOTEL_TYPE_CHANGE'


export const LATEST_SEARCH_LOCAL_STORAGE = 'latestSearch'

export const LOADER_COLOR = '#40e9c4'

/** Search params */
export const SEARCH_PARAM_KEYWORD = 'q'
export const SEARCH_PARAM_DATE_START = 'dateIn'
export const SEARCH_PARAM_DATE_END = 'nbNight'
export const SEARCH_PARAM_ROOM = 'apartment[]'
export const SEARCH_PARAM_HOTEL_ID = 'hotel_id'
export const SEARCH_PARAM_ROOM_ID = 'roomId'
export const SEARCH_PARAM_ROOM_RATE_ID = 'roomRateId'
export const SEARCH_PARAM_APPARTMENT = 'apartment'
export const SEARCH_PARAM_PRICE_RANGE = 'price_range'
export const SEARCH_PARAM_PRICE_RANGE_DYNAMIC = 'price_range_dynamic'
export const SEARCH_PARAM_AMENITIES = 'amenities'
export const SEARCH_PARAM_HOTEL_TYPE = 'hotel_type'
export const SEARCH_PARAM_SORT = 'sort'
export const SEARCH_PARAM_APARTMENT_ID = 'apartment_id'
export const SEARCH_PARAM_HOTEL_DIRECT_ID = 'hotelDirectId'
export const SEARCH_PARAM_CLIENT_CODE = 'clientCode'
export const SEARCH_PARAM_CONTRACT_NUMBER = 'contractNumber'
export const SEARCH_PARAM_IATA_CODE = 'iataCode'
export const SEARCH_PARAM_PROMO_CODE = 'promoCode'
export const SEARCH_PARAM_ERROR_PROMO_CODE = 'errorPromo'
export const SEARCH_PARAM_WRONGPROMO_CODE = 'wrongPromoCode'
export const SEARCH_PARAM_TO_ROOM_RATES = 'toRoomRates'
// Search parameters that could be resetted after destination change.
export const TEMPORARY_SEARCH_PARAMETERS = [SEARCH_PARAM_SORT, SEARCH_PARAM_HOTEL_TYPE, SEARCH_PARAM_AMENITIES, SEARCH_PARAM_PRICE_RANGE_DYNAMIC]

export const BUTTON_OFF = '0'
export const BUTTON_ON = '1'

export const BODY_NO_SCROLL_CLASS = 'no-scroll'
export const BODY_NO_SCROLL_MOBILE_CLASS = 'no-scroll-mobile'

export const FETCH_CONDITIONS_REQUEST = 'SearchResults.FETCH_CONDITIONS_REQUEST'
export const FETCH_CONDITIONS_SUCCESS = 'SearchResults.FETCH_CONDITIONS_SUCCESS'
export const RESET_CONDITIONS_SUCCESS = 'SearchResults.RESET_CONDITIONS_SUCCESS'

export const FETCH_IMAGES_REQUEST = 'SearchResults.FETCH_IMAGES_REQUEST'

export const FETCH_IMAGES_SUCCESS = 'SearchResults.FETCH_IMAGES_SUCCESS'

export const FETCH_FAMILY_FRIENDLY_REQUEST = 'FETCH_FAMILY_FRIENDLY_REQUEST'

export const FETCH_FAMILY_FRIENDLY_DATA_SUCCESS = 'FETCH_FAMILY_FRIENDLY_DATA_SUCCESS'

/** Guests & Rooms */
export const ADULTS_DEFAULT = 2
export const ADULTS_ONE_DAY_BOOKING = 1
export const ADULTS_MIN = 1
export const ADULTS_MAX = 8

export const CHILDREN_DEFAULT = 0
export const CHILDREN_MIN = 0
export const CHILDREN_MAX = 5
export const CHILDREN_AGE_DEFAULT = null
export const CHILDREN_AGE_MIN = 0
export const CHILDREN_AGE_MAX = 17

export const BABIES_DEFAULT = 0
export const BABIES_MIN = 0
export const BABIES_MAX = 5

export const GLOBAL_LOADER_TOGGLE = 'GLOBAL_LOADER_TOGGLE'

export const GLOBAL_LOADER_TIMEOUT = 1000

/** Page View */
export const HOMEPAGE_VIEW = 'homePage'
export const DESTINATIONS_PAGE_VIEW = 'destinationPage'
export const SEARCHPAGE_VIEW = 'searchPage'
export const BASICPAGE_VIEW = 'basicPage'
export const OFFERINDEXPAGE_VIEW = 'offerIndex'
export const OFFERPAGE_VIEW = 'offerPage'
export const DESTINATIONS_ALL_PAGE_VIEW = 'destinations'

/** AB testy Cookie for home search filters */
export const TestAdagioABQA_HOMEPAGE_SEARCH_FILTERS = 'TestAdagioABQA'
export const TestAdagioABQA_HOMEPAGE_SEARCH_FILTERS_WITHVIDEO = 'TestVIDEO'

/** AB testy Cookie for Hotel page Booking block */
export const TestAdagioABQA_HOTELPAGE_left = 'abt865903-1'
export const TestAdagioABQA_HOTELPAGE_right = 'abt865903-2'

/** PromoCode remove */
export const DELETE_PROMO_CODE_INIT = 'SECOND_STEP_ACTION.DELETE_PROMO_CODE_INIT'
export const DELETE_PROMO_CODE_SUCCESS = 'SECOND_STEP_ACTION.DELETE_PROMO_CODE_SUCCESS'
export const DELETE_PROMO_CODE_FAILED = 'SECOND_STEP_ACTION.DELETE_PROMO_CODE_FAILED'
